// extracted by mini-css-extract-plugin
export default {"group":"YCU0","left-group":"MPz2","leftGroup":"MPz2"};